import AsyncControl from '@/Controls/AsyncControl';
import ComponentManager from '@/Management/ComponentManager';
import DummyLayoutViewModelType from '@/ViewModels/Controls/DummyLayoutViewModel';

export default class DummyLayout extends AsyncControl {

    private jQueryControl: JQuery;

    public constructor(private viewModel: DummyLayoutViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public async getElementAsync(): Promise<JQuery> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyBindings(this.jQueryControl, {
            controlName: 'dummylayout',

            controlIdent: this.identifier
        });

        this.widget(null);

        return this.jQueryControl;
    }
}

ComponentManager.setControl('DummyLayout', DummyLayout, 'RADPresentation.HTMLClient.DefaultViewExtensions');